import React, { useContext } from 'react';

import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import { Button, TextButton } from '@xingternal/button';
import { EditContext, PageContext } from '@xingternal/pages-common';
import { trackEditSaving } from '@xingternal/pages-tracking';

import styles from './EditActions.css';

type EditActionsProps = {
  disabled?: boolean;
  discardAction: () => void;
  saveAction: () => void;
  isSaving?: boolean;
  noMarginTop?: boolean;
  default?: string;
};

const EditActions = ({
  disabled,
  discardAction,
  saveAction,
  isSaving,
  noMarginTop = false,
}: EditActionsProps) => {
  const { pageContext } = useContext(PageContext);
  const { trackingData } = useContext(EditContext);
  return (
    <div
      className={cx(styles.actionsContainer, {
        [styles.noMarginTop]: noMarginTop,
      })}
    >
      <TextButton
        size="medium"
        tabindex=""
        className={styles.discardButton}
        data-cy="DISCARD_CONTACT_BUTTON"
        disabled={isSaving || disabled}
        onClick={discardAction}
      >
        <FormattedMessage
          id="EP_EDIT_ACTION_DISCARD"
          defaultMessage="EP_EDIT_ACTION_DISCARD"
        />
      </TextButton>
      <Button
        variant="primary"
        size="medium"
        tabindex=""
        disabled={disabled}
        onClick={() => {
          pageContext?.focusType &&
            trackingData?.module &&
            trackEditSaving({
              focusType: pageContext.focusType,
              itemId: pageContext.pageId,
              module: trackingData.module,
              part: trackingData.part,
            });
          saveAction();
        }}
        data-cy="PUBLISH_CONTACT_BUTTON"
        loading={isSaving}
      >
        <FormattedMessage
          id="EP_EDIT_ACTION_PUBLISH"
          defaultMessage="EP_EDIT_ACTION_PUBLISH"
        />
      </Button>
    </div>
  );
};

export default EditActions;
